import Form, { Field } from '../../../lib/recoil/Form';
import { UsCitizenshipStatus, UsState } from '../../../types/eligibility';

const personalInformationStepForm = new Form({
  fields: {
    applicant_first_name: new Field<string>({
      key: 'applicantFirstName',
      defaultValue: '',
      rules: [
        {
          helperText: 'First name is required',
          pattern: (value) => !!value.trim(),
          severity: 'error',
        },
      ],
    }),
    applicant_last_name: new Field<string>({
      key: 'applicantLastName',
      defaultValue: '',
      rules: [
        {
          helperText: 'Last name is required',
          pattern: (value) => !!value.trim(),
          severity: 'error',
        },
      ],
    }),
    applicant_phone_number: new Field<string>({
      key: 'applicantPhone',
      defaultValue: '',
      rules: [
        {
          helperText: 'Phone number is required',
          pattern: (value) => !!value.trim(),
          severity: 'error',
        },
      ],
    }),
    applicant_email: new Field<string>({
      key: 'applicantEmail',
      defaultValue: '',
      rules: [
        {
          helperText: 'Valid email is required',
          pattern: (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value),
          severity: 'error',
        },
      ],
    }),
    citizenship_status: new Field<UsCitizenshipStatus | null>({
      key: 'citizenshipStatus',
      defaultValue: null,
      rules: [
        {
          helperText: 'required',
          pattern: (value) => value !== null,
          severity: 'error',
        },
      ],
    }),
    address_line: new Field<string>({
      key: 'shortFormAddressLine',
      defaultValue: '',
      rules: [
        {
          helperText: 'Address is required',
          pattern: (value) => !!value.trim(),
          severity: 'error',
        },
      ],
    }),
    address_detail: new Field<string>({
      key: 'shortFormAddressDetail',
      defaultValue: '',
      rules: [],
    }),
    city: new Field<string>({
      key: 'shortFormCity',
      defaultValue: '',
      rules: [
        {
          helperText: 'City is required',
          pattern: (value) => !!value.trim(),
          severity: 'error',
        },
      ],
    }),
    state: new Field<UsState | null>({
      key: 'shortFormState',
      defaultValue: null,
      rules: [
        {
          helperText: 'State is required',
          pattern: (value) => !!value,
          severity: 'error',
        },
      ],
    }),
    zip: new Field<string>({
      key: 'shortFormZip',
      defaultValue: '',
      rules: [
        {
          helperText: 'Zip code must be 5 or 9 digits',
          pattern: (value) => /^\d{5}(?:[-\s]?\d{4})?$/.test(value),
          severity: 'error',
        },
      ],
    }),
  },
});

export default personalInformationStepForm;
